<ng-container>
  <div>
    @if (availableWidthReady$ | async) {
      <div>
        @if (rowDrag) {
          <div [raskRowDrag]="dataSorted">
            <ng-container *ngTemplateOutlet="listContent"></ng-container>
          </div>
        }
        @if (!rowDrag) {
          <div>
            <ng-container *ngTemplateOutlet="listContent"></ng-container>
          </div>
        }
      </div>
    }
  </div>
</ng-container>

<ng-template #listContent>
  @if (!supressHeader) {
    <div class="row header-row" [ngClass]="{'fixed-header': fixedHeader}">
      @for (column of columns; track column; let colidx = $index) {
        <div id="th_{{column.header}}" (click)="setSorting(column)"
          [ngClass]="{'sortable': column.sortable}" class="header-col" [ngStyle]="{'width': columnWidths[colidx]}">
          {{column.header}}
          @if (isSortActive(column) && isSortReverse(column) === false) {
            <span class="far fa-arrow-up"></span>
          }
          @if (isSortActive(column) && isSortReverse(column)) {
            <span class="far fa-arrow-down"></span>
          }
        </div>
      }
    </div>
  }

  <div class="body">
    @for (row of dataSorted; track trackById(rowidx, row); let rowidx = $index; let last = $last) {
      <div [id]="generateId(rowidx)" class="list-row"
        [ngClass]="{'draggable': rowDrag, 'selected': isSelected(rowidx, last), 'thinLine': fixedHeader, 'locked': row.isLocked}">
        <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
        @if (row.headerRow != null) {
          <div class="row inner-header">
            <div class="col-12">
              {{ row.headerRow }}
            </div>
          </div>
        }
        <div class="row">
          @for (column of columns; track column; let colidx = $index; let first = $first) {
            <div class="svea-text row-col"
              [ngClass]="{'ellipsis': column.nowrap, 'centered': column.centered, 'drag-handle': rowDrag && first}"
              [ngStyle]="{'width': columnWidths[colidx], 'max-width': column.nowrap ? columnWidths[colidx] : ''}"
              [attr.colidx]="column.field">
              @if (column.template) {
                <ng-container
                  *ngTemplateOutlet="column.template; context: {row: row, idx: rowidx, $implicit: row[column.field]}">
                </ng-container>
              }
              @if (column.tooltip) {
                <ng-container *ngTemplateOutlet="rawValueWithTooltip; context: {$implicit: row[column.field]}">
                </ng-container>
              }
              @if (!column.template && !column.tooltip) {
                <ng-container *ngTemplateOutlet="rawValue; context: {$implicit: row[column.field]}">{{ row[column.field] }}</ng-container>
              }
            </div>
          }
        </div>
        @if (hasValidationMessages(row)) {
          @for (validationMessage of row.validationMessages; track $index) {
            <div class="validation-container">
              <rask-validation-message-row
                [type]="validationMessage.type"
                [message]="validationMessage.message">
              </rask-validation-message-row>
            </div>
          }
        }
      </div>
    }

    @for (row of customRows; track trackById(rowidx, row); let rowidx = $index) {
      <div [id]="generateRowId(rowidx)" class="list-row custom-row">
        <div class="row">
          @for (column of row.columns; track column; let colidx = $index) {
            <div class="svea-text row-col"
              [ngClass]="{'ellipsis': column.nowrap, 'centered': column.centered}"
              [ngStyle]="{'width': columnWidths[colidx], 'max-width': column.nowrap ? columnWidths[colidx] : ''}">
              <ng-container
                *ngTemplateOutlet="column.template; context: {row: row, $implicit: row[column.field]}">
              </ng-container>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #rawValue let-value>
  {{value}}
</ng-template>

<ng-template #rawValueWithTooltip let-value>
  <span data-bs-toggle="tooltip" data-placement="top" title="{{value}}">
    {{value}}
  </span>
</ng-template>
